module.exports = __webpack_public_path__ + "static/media/p-loader.84b45b2b.gif";